export function cleanEmptyListItems(html) {
  return html.replace(/<li>(\s|&nbsp;|<br\s*\/?>)*<\/li>/gi, "");
}
